/**
 * Add to cart - loading state
 *
 * Zet de native `loading` class van het thema op de submit button zolang een
 * product wordt toegevoegd aan de cart. De animatie zelf staat al in theme.css
 * (.button.loading + @keyframes preloading, het lopende streepje met .btn-text
 * op 0). Werkt op de PDP (buy-buttons + sticky ATC) en op de quick-add in de
 * product card op collectie-, zoek- en homepage-grids.
 *
 * LET OP - waarom `window` en niet `document`:
 * wishlist-king-cart.js vangt submits naar /cart/add af met een capture-listener
 * op document en roept daar `stopImmediatePropagation()` aan, zodat WK zijn
 * eigen redirect niet kan doen. Daardoor draait de submit-handler van het thema
 * niet en bereikt het event nooit de bubble-fase. Een capture-listener op window
 * zit een niveau hoger in de event path en loopt dus altijd als eerste, los van
 * de volgorde waarin de scripts geladen worden.
 *
 * Om diezelfde reden luisteren we voor het opruimen op meerdere signalen:
 *   - ajaxProduct:added / ajaxProduct:error -> theme.js (ProductForm)
 *   - cart:refresh                          -> wishlist-king-cart.js
 *
 * Debug: `localStorage.setItem('atc-loading-debug', '1')` en filter de console
 * op [atc-loading].
 */
(function () {
  const FAILSAFE_DURATION = 8000
  const PREFIX = '[atc-loading]'
  const DEBUG = localStorage.getItem('atc-loading-debug') === '1'

  function log(...args) {
    if (DEBUG) console.log(PREFIX, ...args)
  }

  function clearLoading(event) {
    const buttons = document.querySelectorAll('.button.loading')
    if (!buttons.length) return

    log('opruimen via', event ? event.type : 'failsafe', '-', buttons.length, 'button(s)')
    buttons.forEach((button) => button.classList.remove('loading'))
  }

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target
      if (!(form instanceof HTMLFormElement)) return
      if (!(form.getAttribute('action') || '').includes('/cart/add')) return

      const submitter = event.submitter
      const button = submitter && submitter.type === 'submit' ? submitter : form.querySelector('[type="submit"]')
      if (!button) return

      button.classList.add('loading')
      log('start op', button.closest('.product-card') ? 'product card' : 'PDP / overig', button)

      // Nooit blijven hangen als er geen afrondend event volgt.
      setTimeout(clearLoading, FAILSAFE_DURATION)
    },
    true
  )

  document.addEventListener('ajaxProduct:added', clearLoading)
  document.addEventListener('ajaxProduct:error', clearLoading)
  document.addEventListener('cart:refresh', clearLoading)

  log('geladen')
})()
